import EmptyContent from '@/commons/empty-content/EmptyContent';
import Loader from '@/commons/loader';
import { useFetch } from '@/modules/orders/hooks/useFetch';
import { logsTipsFactureService } from '@/services';
import { translates } from '@/utils';
import { currentFormat } from '@/utils/cases';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
  timelineItemClasses,
} from '@mui/lab';
import { Box, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useEffect } from 'react';

export default function LogsChangeTipsTimeLine({ id }: any) {
  const { data, isLoading, fetchProperties } = useFetch({ fetchFunction: logsTipsFactureService });

  const handleLogTipsFactureService = async (values: any) => {
    try {
      await fetchProperties(id, values);
    } catch (error) {
      console.log('🚀 ~ file: index.tsx:31 ~ handleLogTipsFactureServie ~ error:', error);
    }
  };

  useEffect(() => {
    handleLogTipsFactureService(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  if (isLoading) {
    return <Loader />;
  }
  if (!data?.length) {
    return (
      <Stack justifyContent="center" alignItems="center">
        <EmptyContent
          title={translates.noData}
          sx={{
            '& span.MuiBox-root': { height: 160 },
          }}
        />
      </Stack>
    );
  }
  return (
    <Timeline
      sx={{
        p: 0,
        m: 0,
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 2,
        },
      }}
      placeholder=""
      onPointerEnterCapture={undefined}
      onPointerLeaveCapture={undefined}
    >
      {data.map((item: any) => {
        const { comment, created_at: createdAt, responsibleName } = item;

        return (
          <TimelineItem>
            <TimelineSeparator>
              <TimelineDot variant="filled" color="secondary" />
              <TimelineConnector />
            </TimelineSeparator>

            <TimelineContent>
              <Typography variant="subtitle2">Folio: {item?._id?.slice(0, 7)}</Typography>
              <Typography variant="subtitle2">Orden: {item?.orderId?.slice(0, 7)}</Typography>
              <Stack direction="column" spacing={1}>
                <Stack spacing={0.5}>
                  <Typography variant="caption">
                    Propina Total Anterior: <strong>{currentFormat(item?.beforeTips ?? 0)}</strong>
                  </Typography>
                  <Typography variant="caption">
                    Propina Total Nueva: <strong>{currentFormat(item?.afterTips ?? 0)}</strong>
                  </Typography>
                </Stack>
                <Stack spacing={0.5}>
                  <Typography variant="caption">
                    Propina Weeks Anterior:{' '}
                    <strong>{currentFormat(item?.beforeTipsCompany ?? 0)}</strong>
                  </Typography>
                  <Typography variant="caption">
                    Propina Weeks Nueva:{' '}
                    <strong>{currentFormat(item?.afterTipsCompany ?? 0)}</strong>
                  </Typography>
                </Stack>
              </Stack>
              <Box sx={{ color: 'text.disabled', typography: 'caption', mt: 0.5 }}>{comment}</Box>
              <Box sx={{ color: 'text.disabled', typography: 'caption', mt: 0.5 }}>
                {dayjs(createdAt).format('DD/MM/YY hh:mm A')}
              </Box>
              <Box sx={{ color: 'text.disabled', typography: 'caption', mt: 0.5 }}>
                <strong>Responsable:</strong> {responsibleName?.name}
              </Box>
            </TimelineContent>
          </TimelineItem>
        );
      })}
    </Timeline>
  );
}
